import linkifyIt from 'linkify-it';

/* handle twitter mention and transform it as link */
var twitterHandler = {
  validate: function validate(text, pos, self) {
    var tail = text.slice(pos);

    if (!self.re.twitter) {
      self.re.twitter = new RegExp('^([a-zA-Z0-9_]){1,15}(?!_)(?=$|' + self.re.src_ZPCc + ')');
    }
    if (self.re.twitter.test(tail)) {
      if (pos >= 2 && tail[pos - 2] === '@') {
        return false;
      }
      return tail.match(self.re.twitter)[0].length;
    }
    return 0;
  },
  normalize: function normalize(match) {
    match.url = 'https://twitter.com/' + match.url.replace(/^@/, '');
  }
};

var linkify = linkifyIt().tlds(require('tlds')) // Reload with full tlds list
.tlds('onion', true) // Add unofficial `.onion` domain
.add('git:', 'http:') // Add `git:` protocol as "alias"
.add('ftp:', null) // Disable `ftp:` protocol
.add('@', twitterHandler).set({ fuzzyIP: true });

export var findAll = function findAll(str) {
  return linkify.match(str);
};
//# sourceMappingURL=url.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-misc/lib/utils/url.js
// module id = 399
// module chunks = 0